import { render, staticRenderFns } from "./GogoSupport.vue?vue&type=template&id=f8df709a&scoped=true"
var script = {}
import style0 from "./GogoSupport.vue?vue&type=style&index=0&id=f8df709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8df709a",
  null
  
)

export default component.exports